import React from 'react';
import { Box, Paper } from '@mui/material';
import { SIDEBAR_CONFIG, getSidebarWidth } from '@core/constants/config';
import { useAppLayout } from '@core/contexts/LayoutContext';
import LayoutMainContent from './LayoutMainContent';
import LayoutUserAccount from './LayoutUserAccount';
import Sidebar from './Sidebar';
import WebTwoContextHeader from './WebTwoContextHeader';

const WebTwoLayout: React.FC = () => {
  const {
    visibleNavItems,
    routeConfig,
    userAccount,
    expandedLogo: ExpandedLogo,
  } = useAppLayout();

  const hasExpandedLogo = ExpandedLogo != null;
  const resolvedLogoHeight = hasExpandedLogo
    ? ExpandedLogo.logoHeight
    : SIDEBAR_CONFIG.LOGO_HEIGHT;
  const sidebarWidth = ExpandedLogo?.logoWidth ?? getSidebarWidth(true);

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        bgcolor: 'background.default',
        position: 'relative',
      }}
    >
      {ExpandedLogo ? (
        <ExpandedLogo.component
          sidebarOpen={true}
          logoHeight={resolvedLogoHeight}
        />
      ) : null}

      <Sidebar
        open={true}
        collapsible={false}
        onToggle={() => undefined}
        navItems={visibleNavItems}
        logoHeight={resolvedLogoHeight}
        showLogo={!hasExpandedLogo}
        width={sidebarWidth}
        footer={<LayoutUserAccount {...userAccount} variant="sidebar" />}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          maxHeight: '100vh',
          minWidth: 0,
          maxWidth: '100%',
          position: 'relative',
          zIndex: 1000,
          marginLeft: `${sidebarWidth}px`,
        }}
      >
        <WebTwoContextHeader />

        <Box
          sx={{
            flex: 1,
            minWidth: 0,
            minHeight: 0,
            p: 0,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Paper
            elevation={0}
            sx={{
              flex: 1,
              minWidth: 0,
              minHeight: 0,
              display: 'flex',
              flexDirection: 'column',
              borderRadius: 0,
              p: 3,
              pt: 1,
              bgcolor: 'background.paper',
              border: undefined,
              borderColor: undefined,
              '--Paper-shadow': 'none',
            }}
          >
            <LayoutMainContent routeConfig={routeConfig} />
          </Paper>
        </Box>
      </Box>
    </Box>
  );
};

export default WebTwoLayout;
